import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { scrollToElement } from "../common/forms";
import { error, isEmpty } from "../common/global";
import { catchError } from "../../utils/errorUtil";

//importing checkout function for dealership selection event
import { initDealershipMapEvents } from "../ui/checkout";


const props = {
    locateDealershipMarker: '#m-locate-dealership',
    selectDealershipMarker: '#delivery-dealership-wrapper',
    myLocation: '#location',
    shareLocation: '#share-location',
    searchByLocation: '#search-by-location',
    dealershipMap: '#dealership-map',
    dealershipList: '#dealership-list',
    dealershipResultsListWrapper: '#dealership-results-wrapper',
    dealershipForCheckoutResultsListWrapper: '#dealership-results-wrapper',
    //filters
    filterOption: '.filter-item'
};

var geocoder = null;
var map = null;
var infoWindow = null;

var customerMarker = null;
var dealershipMarker, i = null;
var maxReturnedLocationCount = null;

var gmarkers = [];

// Define the bounds of the UK
var allowedBounds = null;
var inspectionsOffered = false;

export async function initLocateDealership() {

    if ($(props.locateDealershipMarker).length) {

        //initialise maxReturnedLocationCount to set the maximum number of dealerships that can be returned
        maxReturnedLocationCount = 10;

        initialiseMapEvents();

        await initialiseDealershipMap();
    }

    if ($(props.selectDealershipMarker).length) {

        maxReturnedLocationCount = 3;
        inspectionsOffered = true;

        initialiseCheckoutMapEvents();

        await initialiseDealershipMap();
    }
}

async function initialiseDealershipMap() {

    allowedBounds = new google.maps.LatLngBounds();

    geocoder = new google.maps.Geocoder();
    var latlng = new google.maps.LatLng(55, -1);
    var mapOptions = {
        zoom: 5,
        minZoom: 5,
        center: latlng,
        mapTypeControl: false,
        fullscreenControl: false,
        //mapTypeId: google.maps.MapTypeId.ROADMAP,
        region: 'uk'//,
        //styles: [{ "featureType": "all", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": "35" }, { "gamma": "1" }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "off" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.locality", "elementType": "geometry.fill", "stylers": [{ "lightness": "-11" }] }, { "featureType": "administrative.locality", "elementType": "labels.text", "stylers": [{ "color": "#fc5d1e" }] }, { "featureType": "administrative.land_parcel", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "poi.park", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#475058" }, { "lightness": "-48" }, { "saturation": "-73" }, { "weight": "3.98" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "lightness": "7" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "lightness": "63" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }, { "visibility": "off" }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "lightness": "-8" }, { "gamma": "1.73" }] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [{ "lightness": "-1" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "lightness": "24" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#475058" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#d1e0e9" }, { "lightness": "-70" }, { "saturation": "-75" }] }, { "featureType": "water", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "lightness": "-54" }, { "hue": "#ff0000" }] }]
    };
    map = new google.maps.Map(document.getElementById("dealership-map"),
        mapOptions);

    // ***** Markers *****
    infoWindow = new google.maps.InfoWindow();

    google.maps.event.addListenerOnce(map, 'idle', function () {
        // do something only the first time the map is loaded
        if (!isEmpty($(props.myLocation).val())) {

            //if the search locaton text box has a value on load then auto run the search function
            $(props.searchByLocation).click();
        }
    });
    
}

async function initialiseMapEvents() {

    initShareUrlEvent();

    $(props.searchByLocation).off('click').on('click', function (e) {

        geocodeAddress(injectNearestDealershipsList);

        buildDynamicUrl();
    });

    //search when enter key is pressed
    $(props.myLocation).off("keypress").on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            geocodeAddress(injectNearestDealershipsList);

            buildDynamicUrl();
        }
    });

    $(props.filterOption).off('click').on('click', function (e) {

        //manage status of the clicked filter option, then call function to rebuild map data
        if ($(this).hasClass('selected')) {

            $(this).removeClass('selected');

        } else {

            $(this).addClass('selected');
        }

        geocodeAddress(injectNearestDealershipsList);
    });
}


async function initialiseCheckoutMapEvents() {

    $(props.searchByLocation).off('click').on('click', function (e) {

        geocodeAddress(injectNearestDealershipsForCheckoutList);
    });

    //search when enter key is pressed
    $(props.myLocation).off("keypress").on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            geocodeAddress(injectNearestDealershipsForCheckoutList);
        }
    });
}


// Search - set to find nearest 10.
async function geocodeAddress(callback) {

    var address = document.getElementById('location').value;

    if (isEmpty(address)) {
        return;
    }

    //restrict results to the UK
    //source: https://stackoverflow.com/questions/2647086/googles-geocoder-returns-wrong-country-ignoring-the-region-hint
    address = address + ', UK';

    //create elements tyo set bounds to a UK shaped rectangle
    var sw = new google.maps.LatLng(50.064192, -9.711914)
    var ne = new google.maps.LatLng(61.015725, 3.691406)
    var viewport = new google.maps.LatLngBounds(sw, ne);

    geocoder.geocode({
        'address': address,
        'region': 'uk',
        'bounds': viewport
    }, async function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {

            //no need to check for zero results returned; GeocoderStatus will === ZERO_RESULTS if this is the case (handled below).

            if (customerMarker) customerMarker.setMap(null);

            allowedBounds = new google.maps.LatLngBounds();

            customerMarker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location
            });

            var customLat = results[0].geometry.location.lat();
            var customLng = results[0].geometry.location.lng();

            allowedBounds.extend(new google.maps.LatLng(customLat, customLng));

            //TODO: review usage of panto and fitBounds (in createMarkers) when more data available. not smooth at presentmap.panTo(results[0].geometry.location);

            var selectedFilters = [];

            $(props.filterOption + '.selected').each(function () {
                selectedFilters.push($(this).data('filter-id'));
            });

            const defaultFilterId = $(props.dealershipMap).data("default-filter");
            
            if (defaultFilterId)
                selectedFilters.push(defaultFilterId);

            let data = {
                latitude: customLat,
                longitude: customLng,
                maxReturnedLocationCount: maxReturnedLocationCount,
                inspectionsAvailableOnly: inspectionsOffered,
                selectedFilters: selectedFilters
            };

            const dealershipSearchResult = await getNearestDealershipsService(data);

            clearLocations();

            await createMarkers(dealershipSearchResult.dealerships);

            callback(data);

        } else {
            if (status === "ZERO_RESULTS") {

                openDialog({
                    ...dialogModel,
                    title: 'Your search did not return any results',
                    content: 'Try using the first line of your address or your postcode.',
                    displayConfirm: false,
                    cancelButtonText: 'Close'
                });

                return;
            }

            alert('Geocode was not successful for the following reason: ' + status);
        }

    });
}


async function createMarkers(data) {

    $.map(data, function (item) {

        // Check if store has a lat and long
        if (item.latitude && item.longitude) {
            // Store has a lat and long, set dealershipMarker
            setMarkers(item.latitude, item.longitude);
        }

        // Set Markers Function
        function setMarkers(lat, lng) {

            // Set Markers
            var markerIcon = {
                url: "/images/core/dealerships/finder.png",
                scaledSize: new google.maps.Size(26, 35)
            };

            // Adds new dealershipMarker for each
            dealershipMarker = new google.maps.Marker({
                map: map,
                position: new google.maps.LatLng(lat, lng),
                title: item.name,
                icon: markerIcon
            });

            // Build info Window
            var iwContent = '<div id="content">' +
                '<div class="text-size-rem-10 font-weight-bold">' + item.name + '</div>' +
                '<p><strong>Phone: </strong><a href="tel:' + item.contactNumber + '">' + item.contactNumber + '</a></p>' +
                // '<p><strong>Email:</strong> ' + item.EmailAddress + '</p>' +
                '</div>';

            allowedBounds.extend(new google.maps.LatLng(lat, lng));

            //Links up the infoWindow on click event
            gmarkers.push(dealershipMarker);

            google.maps.event.addListener(dealershipMarker, 'click', (function (dealershipMarker, i) {
                return function () {
                    infoWindow.setContent(iwContent);
                    infoWindow.open(map, dealershipMarker);
                }
            })
                (dealershipMarker, i));

        }
    });

    map.fitBounds(allowedBounds);

    scrollToElement($(props.searchByLocation), 500, true, 50);
}

async function injectNearestDealershipsList(data) {

    const result = await buildNearestDealershipsListService(data);

    await injectHtml(props.dealershipResultsListWrapper, result);

    setTimeout(function () {

        //TODO: bind any events that may be required.

        $('#dealership-results-wrapper [data-toggle="tooltip"]').tooltip();

    }, 100);

}

async function injectNearestDealershipsForCheckoutList(data) {

    const result = await buildNearestDealershipsForCheckoutListService(data);

    await injectHtml(props.dealershipForCheckoutResultsListWrapper, result);

    setTimeout(function () {

        //bind dealership selection events. NOTE: these are imported from the checkout file.
        initDealershipMapEvents();

    }, 100);

}


function clearLocations() {

    infoWindow.close();

    map.getStreetView().setVisible(false);

    // Remove markers from map and array
    for (var i = 0; i < gmarkers.length; i++) {
        gmarkers[i].setMap(null);
    }
    gmarkers.length = 0;
}


function buildDynamicUrl() {

    //currently this only utilises the value of the search text box
    var locationValue = $(props.myLocation).val();
    var urlQuerystring = '';

    if (history.pushState) {

        if (!isEmpty(locationValue)) {

            urlQuerystring = '?location=' + locationValue;
        }

        var newurl = window.location.origin + window.location.pathname + urlQuerystring;
        window.history.pushState({ path: newurl }, '', newurl);
    }

}

function initShareUrlEvent() {

    $(props.shareLocation).off('click').on('click', function (e) {

        var dummy = document.createElement('input'),
            text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

        $(props.shareLocation).tooltip('show');

        setTimeout(function () {

            $(props.shareLocation).tooltip('hide');

        }, 1500);

    });

}



//API CALLS

async function getNearestDealershipsService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/support/getnearestdealerships', data);

    return response.data;
}


async function buildNearestDealershipsListService(data) {

    //no TRY CATCH as handled by parent
    //NOTE: post must be used or the selected filters list is lost
    const response = await http.post('/support/buildnearestdealershipslist', data);

    return response.data;
}

async function buildNearestDealershipsForCheckoutListService(data) {

    //no TRY CATCH as handled by parent
    //NOTE: post must be used or the selected filters list is lost
    const response = await http.post('/support/buildnearestdealershipsforcheckoutlist', data);

    return response.data;
}


